<template>
	<div class="pr-login-container">
		

		<form v-on:submit.prevent="submitLogin">
			<div class="alert" :class="{'alert-danger': credentials.callback.error, 'alert-success': !credentials.callback.error}" v-if="credentials.callback.message">{{credentials.callback.message}}</div>

			<div class="pr-input-group">
				<label>Protocolo</label>
				<input type="text" v-mask="['XXXX-XXXX']" required class="form-control pr-login-input" v-model="credentials.login" name="loginProtocolo" ref="loginProtocolo" placeholder="Protocolo" />
			</div>
			
			<div class="pr-input-group">
				<label>Senha</label>
				<input type="text" v-mask="['XXXX-XXXX']" required class="form-control pr-login-input" v-model="credentials.password" name="loginProtocoloPassword" ref="loginProtocoloPassword" placeholder="Senha" />
			</div>

			<button type="submit" class="pr-btn">Acessar</button>
		</form>
	</div>
</template>

<script>
import { Auth } from "@/services"
import messages from '@/messages.json'

export default {
	name: 'prLogin',
	data() {
		return {
			credentials: {
				login: "",
				dtnasc: null,
				password: "",
				callback: {
					message: null,
					error: null
				}
			}
		};
	},
	mounted() {
		const urlParams = new URLSearchParams(window.location.search);
		this.credentials.login = urlParams.get('protocol');
		this.credentials.password = urlParams.get('password');
	},
	methods: {
		submitLogin(ev) {
			this.credentials.callback.error = null;
			this.credentials.callback.message = "Verificando...";

			Auth.loginPatient({
				login: this.credentials.login.replace("-", ""),
				password: this.credentials.password.replace("-", ""),
				loginMethod: "PROTOCOLO"
			})
				.then(response => response.data)
				.then(data => {
					// try {
					// 	//let win = window.open(`http://localhost:8080/#/login/authorize/${data.token}`, '_blank');
					// 	let win = window.open(`https://exames.image2doc.com.br/#/login/authorize/${data.token}`, '_blank');
					// 	win.focus();
					// }catch(e) {
					// 	this.credentials.callback.error = true;
					// 	this.credentials.callback.message = messages.error.popupBlocked;
					// }
					window.location = `https://exames.image2doc.com.br/#/login/authorize/${data.token}`;
				})
				.catch(error => {
					this.credentials.callback.error = true;
					this.credentials.callback.message = messages.error.invalidLogin;
				});
		}
	}
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/external/loginComponent.vue